'use client';
import React, { useState, useEffect } from 'react';

export default function LiveBadge() {
  const [spotsLeft, setSpotsLeft] = useState(7);

  // In production: replace with a backend call to get remaining slot count
  useEffect(() => {
    const stored = sessionStorage.getItem('lxp-spots');
    if (stored) {
      setSpotsLeft(parseInt(stored, 10));
    }
  }, []);

  return (
    <div className="flex flex-col sm:flex-row items-center gap-3">
      <div className="badge-limited flex items-center gap-2">
        <span className="relative flex h-2 w-2">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75" />
          <span className="relative inline-flex rounded-full h-2 w-2 bg-primary" />
        </span>
        Limited Availability
      </div>
      <span className="text-sm text-muted-foreground">
        Only{' '}
        <span className="text-primary font-bold">{spotsLeft}</span>
        {' '}access slots remaining this week
      </span>
    </div>
  );
}